// extracted by mini-css-extract-plugin
module.exports = {"popover":"Popover_popover__FPpm-","top":"Popover_top__3efyV","container":"Popover_container__3c1dj","animate":"Popover_animate__JBtle"};